import AdminView from './AdminView';
import UserContractorView from './UserContractorView';
import SupplierView from './SupplierView';
import { useRole } from '../../../hooks/useRole';

export default function Requests() {
	const { isAdmin, isStaff, isSupplier } = useRole();

	if (isAdmin || isStaff) {
		return <AdminView />;
	}

	if (isSupplier) {
		return <SupplierView />;
	}

	return <UserContractorView />;
}
